import React from 'react';
import { Row, Col } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import { colors } from 'settings/theme';
import BundleUtil from 'utils/BundleUtil';
import ScreenSizeUtil from 'utils/ScreenSizeUtil';

import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';
import SectionHeading from 'components/SectionHeading';
import Typography from 'components/vistaprintUILibrary/Typography';

import CochranGlassLogoSrc from 'images/customer-logos/cochran-glass.png';
import TheEmploymentNetworkLogoSrc from 'images/customer-logos/the-employment-network.png';
import TheLittleMemoryGalleryLogoSrc from 'images/customer-logos/the-little-memory-gallery.png';

function WhatPeopleAreSaying(props) {
  const {
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <Row
      style={{
        backgroundColor: colors.grayLight,
        marginBottom: 50,
      }}
    >
      <Col>
        <div
          style={{
            boxSizing: 'border-box',
            paddingTop: 50,
            paddingBottom: 50,
          }}
        >
          <SectionHeading
            text={text('what-people-are-saying')}
            alignment="center"
            containerStyle={{
              marginBottom: 40,
            }}
          />
          <div className="carousel carousel-skin-basic">
            {[
              {
                text: text('your-design-team-is-professional'),
                author: {
                  name: 'Daryll Macklin',
                  logo: null,
                  businessName: null,
                },
              },
              {
                text: text('the-artist-was-exceptional'),
                author: {
                  name: 'Kim Cochran',
                  logo: BundleUtil.getFullyQualifiedURL(CochranGlassLogoSrc),
                  businessName: 'Cochran Glass & Mirror',
                },
              },
              {
                text: text('your-designer-came-back'),
                author: {
                  name: 'Marie Carroll-O\'Sullivan',
                  logo: BundleUtil.getFullyQualifiedURL(TheLittleMemoryGalleryLogoSrc),
                  businessName: 'The Little Memory Garden',
                },
              },
              {
                text: text('the-service-rep-was-very-knowledgeable'),
                author: {
                  name: 'Linda Simmons',
                  logo: BundleUtil.getFullyQualifiedURL(TheEmploymentNetworkLogoSrc),
                  businessName: 'The Employment Network',
                },
              },
            ].map(quote => (
              <div
                key={`carousel-slide-${quote.author.name.split(' ').join('')}`}
                className="carousel-slide"
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingLeft: isSmallScreen ? 0 : 50,
                    paddingRight: isSmallScreen ? 0 : 50,
                  }}
                >
                  <Typography
                    variant="quote"
                    text={`"${quote.text}"`}
                    style={{
                      fontSize: isSmallScreen ? '1.2em' : '1.5em',
                      marginBottom: 20,
                      textAlign: 'center',
                    }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: isSmallScreen ? 'column' : 'row',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      style={{
                        marginRight: 10,
                        marginBottom: 20,

                        maxWidth: '90%', // todo: why can't this be 100%?
                      }}
                      src={quote.author.logo}
                      alt={quote.author.businessName}
                    />
                    <div>
                      <Typography
                        text={quote.author.name}
                        style={{
                          textAlign: isSmallScreen ? 'center' : 'left',
                          fontWeight: 'bold',
                        }}
                      />
                      <Typography
                        text={quote.author.businessName}
                        style={{
                          textAlign: isSmallScreen ? 'center' : 'left',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
}

WhatPeopleAreSaying.propTypes = {
  ...withScreenClassPropTypes,
};

export default withScreenClass(WhatPeopleAreSaying);



// WEBPACK FOOTER //
// ./src/components/WhatPeopleAreSaying.js